// @ts-nocheck
import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
// material
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import { makeStyles } from '@material-ui/core/styles';
// Untils
import { sortArrayBy } from 'utils/arrayFunctions';
// styles
// components
import Paths from 'utils/paths';
// icons
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import WorkIcon from '@material-ui/icons/Work';
import SecurityIcon from '@material-ui/icons/Security';
import ReceiptIcon from '@material-ui/icons/Receipt';
import DynamicFeedIcon from '@material-ui/icons/DynamicFeed';
import OpenInBrowserIcon from '@material-ui/icons/OpenInBrowser';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import AssessmentIcon from '@material-ui/icons/Assessment';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate';
// import AssignmentLateIcon from '@material-ui/icons/AssignmentLate';
import EventNoteIcon from '@material-ui/icons/EventNote';
import Permits from 'utils/permits';
import {
  canAccessMaintainer,
  canAccessModule,
  getAccessPolicy,
  getCurrentSubdomain,
} from 'utils/accessPolicy';
import NavBar from '../NavBar';
import styles from './styles';

const useStyles = makeStyles(styles);
const useStylesList = makeStyles((theme) => ({
  nested: {
    paddingLeft: theme.spacing(7),
  },
}));

function SideBar(props) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [reportsOpen, setReportsOpen] = useState(false);
  const classes = useStyles();
  const listClasses = useStylesList();

  const { isOpen, toggleDrawer, role, user, handleItemClick, permissions = [] } = props;
  const accessPolicy = getAccessPolicy({
    subdomain: getCurrentSubdomain(),
    roleName: role?.name,
  });

  const handleClick = () => {
    setOpen(!open);
  };

  const handleClickReports = () => {
    setReportsOpen(!reportsOpen);
  };

  const createMenu = (
    label = undefined,
    module = undefined,
    icon = undefined,
    permits = undefined,
    requiredPermission = undefined,
  ) => ({
    label,
    module,
    icon,
    permits,
    requiredPermission,
  });

  const views = [
    createMenu(t('Acquisitions and expenses'), Paths.PURCHASES, <ReceiptIcon />, Permits.PURCHASES),
    createMenu(t('Receptions'), Paths.RECEIPTS, <OpenInBrowserIcon />, Permits.RECEIPTS),
    createMenu(t('Processes'), Paths.PROCESSES, <DynamicFeedIcon />, Permits.PROCESSES),
    createMenu(t('Dispatches'), Paths.DISPATCHES, <LocalShippingIcon />, Permits.DISPATCHES),
    createMenu(t('Returns'), Paths.RETURNS, <AssignmentLateIcon />, Permits.RETURNS),
    createMenu(t('Paks'), Paths.LOTS, <AllInboxIcon />, Permits.LOTS),
    createMenu(t('Schedule Management'), Paths.SCHEDULE_MANAGEMENT, <EventNoteIcon />, Permits.SCHEDULE_MANAGEMENT, 'schedule_management'),
    createMenu(t('Permissions.title'), Paths.FEATURE_FLAGS, <SecurityIcon />, Permits.FEATURE_FLAGS),
  ];

  const maintainers = [
    createMenu(t('Warehouses'), Paths.WAREHOUSES),
    createMenu(t('Clients'), Paths.CLIENTS),
    createMenu(t('Paddocks'), Paths.PADDOCKS),
    createMenu(t('Employees'), Paths.EMPLOYEES),
    createMenu(t('Containers'), Paths.PACKAGING_TYPES),
    createMenu(t('Species'), Paths.FRUITS),
    createMenu(t('Products'), Paths.PRODUCTS),
    createMenu(t('Supply products'), Paths.SUPPLY_PRODUCTS),
    createMenu(t('Process categories'), Paths.PROCESS_CATEGORIES),
    createMenu(t('modules.sidebarTitle'), Paths.MODULES),
    createMenu(t('Suppliers'), Paths.SUPPLIERS),
    createMenu(t('Process types'), Paths.PROCESS_TYPES),
    createMenu(t('Shifts'), Paths.WORKSHIFTS),
    createMenu(t('Units'), Paths.UNITS),
    createMenu(t('Varieties'), Paths.VARIETIES),
    createMenu(t('Equipments'), Paths.EQUIPMENTS),
    createMenu(t('Users'), Paths.USERS),
    createMenu(t('Carriers'), Paths.CARRIERS, Permits.CARRIERS),
    createMenu(t('Processing plants'), Paths.PROCESSING_PLANTS, Permits.PROCESSING_PLANTS),
  ];

  return (
    <Drawer classes={classes} open={isOpen} onClose={toggleDrawer}>
      <NavBar toggleDrawer={toggleDrawer} withoutLogout />
      <List>
        {views
          .filter((view) => {
            const isRestricted = permissions && permissions.includes('schedule_management');
            const isGonzalo = user?.email === 'gonzalo@tcit.cl';
            const moduleKey = Object.entries(Paths).find(([, path]) => path === view.module)?.[0];
            
            if (view.module === Paths.FEATURE_FLAGS && !isGonzalo) {
              return false;
            }

            if (isRestricted && view.module !== Paths.SCHEDULE_MANAGEMENT && !(isGonzalo && view.module === Paths.FEATURE_FLAGS)) {
              return false;
            }

            return (
              ((view.permits && view.permits.includes(role.name)) ||
                (view.module === Paths.FEATURE_FLAGS && isGonzalo)) &&
              canAccessModule(moduleKey, accessPolicy) &&
              (!view.requiredPermission || permissions.includes(view.requiredPermission))
            );
          })
          .map((view) => (
            <ListItem onClick={handleItemClick(view.module)} button key={`menu-${view.label}`}>
              <ListItemIcon>{view.icon}</ListItemIcon>
              <ListItemText primary={view.label} />
            </ListItem>
          ))}
        {['admin', 'operator', 'packing_manager', 'reception_dispatch_manager'].includes(role.name) &&
          canAccessModule('INVENTORY_LINES', accessPolicy) &&
          !permissions.includes('schedule_management') && (
            <>
              <ListItem button onClick={handleClickReports}>
                <ListItemIcon>
                  <AssessmentIcon />
                </ListItemIcon>
                <ListItemText primary={t('Reports')} />
                {reportsOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={reportsOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {canAccessModule('INVENTORY_LINES', accessPolicy) && (
                    <ListItem
                      onClick={handleItemClick(Paths.INVENTORY_LINES)}
                      button
                      className={listClasses.nested}
                      key="sub-menu-inventory">
                      <ListItemText primary={t('Inventory')} />
                    </ListItem>
                  )}
                  {['admin'].includes(role.name) && canAccessModule('PRODUCTS_REPORT', accessPolicy) && (
                    <ListItem
                      onClick={handleItemClick(Paths.PRODUCTS_REPORT)}
                      button
                      className={listClasses.nested}
                      key="sub-menu-products">
                      <ListItemText primary={t('Margin and production')} />
                    </ListItem>
                  )}
                  {['admin', 'operator', 'packing_manager', 'reception_dispatch_manager'].includes(
                    role.name,
                  ) && canAccessModule('BALANCE', accessPolicy) && (
                      <ListItem
                        onClick={handleItemClick(Paths.BALANCE)}
                        button
                        className={listClasses.nested}
                        key="sub-menu-balance">
                        <ListItemText primary={t('Mass balance')} />
                      </ListItem>
                    )}
                  {['admin'].includes(role.name) && canAccessModule('VERSION_HISTORY', accessPolicy) && (
                    <ListItem
                      onClick={handleItemClick(Paths.VERSION_HISTORY)}
                      button
                      className={listClasses.nested}
                      key="sub-menu-history">
                      <ListItemText primary={t('Change history')} />
                    </ListItem>
                  )}
                </List>
              </Collapse>
            </>
          )}
        {(['admin'].includes(role.name) || accessPolicy.restricted) &&
          !permissions.includes('schedule_management') &&
          maintainers.some((maintainer) => {
            const moduleKey = Object.entries(Paths).find(([, path]) => path === maintainer.module)?.[0];
            return canAccessMaintainer(moduleKey, accessPolicy);
          }) && (
          <>
            <ListItem button onClick={handleClick}>
              <ListItemIcon>
                <WorkIcon />
              </ListItemIcon>
              <ListItemText primary={t('Masters')} />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {sortArrayBy(maintainers, 'ASC', 'label')
                  .filter((maintainer) => {
                    const moduleKey = Object.entries(Paths).find(([, path]) => path === maintainer.module)?.[0];
                    return canAccessMaintainer(moduleKey, accessPolicy);
                  })
                  .map((maintainer) => (
                  <ListItem
                    onClick={handleItemClick(maintainer.module)}
                    button
                    className={listClasses.nested}
                    key={`sub-menu-${maintainer.label}`}>
                    <ListItemText primary={maintainer.label} />
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </>
        )}
        {['admin'].includes(role.name) && permissions.includes('schedule_management') && (
          <>
            <ListItem button onClick={handleClick}>
              <ListItemIcon>
                <WorkIcon />
              </ListItemIcon>
              <ListItemText primary={t('Masters')} />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  onClick={handleItemClick(Paths.SUPPLIERS)}
                  button
                  className={listClasses.nested}
                  key="sub-menu-suppliers">
                  <ListItemText primary={t('Suppliers')} />
                </ListItem>
                <ListItem
                  onClick={handleItemClick(Paths.CARRIERS)}
                  button
                  className={listClasses.nested}
                  key="sub-menu-carriers">
                  <ListItemText primary={t('Carriers')} />
                </ListItem>
                <ListItem
                  onClick={handleItemClick(Paths.PROCESSING_PLANTS)}
                  button
                  className={listClasses.nested}
                  key="sub-menu-processing-plants">
                  <ListItemText primary={t('Processing plants')} />
                </ListItem>
                <ListItem
                  onClick={handleItemClick(Paths.USERS)}
                  button
                  className={listClasses.nested}
                  key="sub-menu-users">
                  <ListItemText primary={t('Users')} />
                </ListItem>
              </List>
            </Collapse>
          </>
        )}
      </List>
    </Drawer>
  );
}

export default SideBar;
